import React from 'react'

export default function ClientSection ({pageName, title, image,background_color,font_color,full_screen }) {
  const pageStyles={
    ...(background_color && { background: background_color }),
    ...(font_color && {  color:font_color }),
  }
  return (
    <div style={{...pageStyles}} className='flex w-full items-center justify-center py-12' id={pageName}>
      <div className='flex flex-col m-auto'>
       {title &&  <p className=' mb-4 font-medium text-center text-header3 uppercase font-text_highlight'>
          {title}
        </p>}
        {image?.url && <img
          src={image?.url}
          title={title}
          alt='the Author'
          className={`${full_screen?'':'max-w-4xl'} w-full object-contain m-auto`}
        />}
      </div>
    </div>
  )
}
